import domready from 'domready';
import 'lazysizes';
import { ResizeHandler } from './landingPage/utilities/resize-handler';

// Animations
import { TextAnimation } from './landingPage/global-animations/text-animation';
import { MovingBulbs } from './landingPage/global-animations/moving-bulbs';

// Areas
import { Stage } from './landingPage/areas/stage';
import { TextMedia } from './landingPage/areas/text-media';
import { Bento } from './landingPage/areas/bento';
import { Usp } from './landingPage/areas/usp';
import { ContentSlider } from './landingPage/areas/content-slider';

// Components
import { FloatingBar } from './landingPage/components/floating-bar';
import { StickyBulbs } from './landingPage/components/sticky-bulbs';

// GLOBAL OPTIONS
const OPTIONS = { // eslint-disable-line
    breakpoints: {
        s: 320,
        m: 768,
        l: 1024,
        xl: 1280,
        xxl: 1440,
        xxxl: 1920,
    },
};

window.resizeHandler = new ResizeHandler();

window.youtubeApi = false;
window.youtubeApiLoading = false;

const browserCheck = () => {
    window.browser = {
        csshover: !window.matchMedia('(pointer:coarse)').matches,
        ios: (/iPhone|iPad|iPod/i).test(navigator.userAgent),
        iphone: (/iPhone|iPod/i).test(navigator.userAgent),
        android: (/(android)/i).test(navigator.userAgent),
        firefox: (/firefox/i).test(navigator.userAgent),
        safari: (/Version\/[\d.]+.*Safari/).test(navigator.userAgent),
    };

    Object.entries(window.browser).forEach(([key, value]) => {
        document.documentElement.classList.add((!value) ? `no-${ key }` : `${ key }`);
    });
};

const checkInview = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.1 });

    const $inviews = document.querySelectorAll('[data-inview]:not(.inview)');
    $inviews.forEach((target) => {
        observer.observe(target);
    });
};

domready(function() {
    const initApplication = () => {
        browserCheck();

        window.resizeHandler.init();

        /* GLOBAL ANIMATION */
        // Text animation
        const $$textanimation = document.querySelectorAll('[data-research-ai-landingpage-textanimation');
        for (let i = 0; i < $$textanimation.length; i++) {
            const $textanimation = $$textanimation[i];

            const $textanimationAPI = new TextAnimation($textanimation);
            $textanimationAPI.initialize();
        }

        // Moving Bulbs
        const $$movingbulbs = document.querySelectorAll('[data-research-ai-landingpage-movingbulbs="root"]');
        for (let i = 0; i < $$movingbulbs.length; i++) {
            const $movingbulbs = $$movingbulbs[i];

            const $movingbulbsAPI = new MovingBulbs($movingbulbs);
            $movingbulbsAPI.initialize();
        }

        /* AREAS */
        // Stage
        const $$stage = document.querySelectorAll('[data-research-ai-landingpage-stage="root"]');
        for (let i = 0; i < $$stage.length; i++) {
            const $stage = $$stage[i];

            const $stageAPI = new Stage($stage);
            $stageAPI.initialize();
        }

        // Usp
        const $$usp = document.querySelectorAll('[data-research-ai-landingpage-usp="root"]');
        for (let i = 0; i < $$usp.length; i++) {
            const $usp = $$usp[i];

            const $uspAPI = new Usp($usp);
            $uspAPI.initialize();
        }

        // Text Media
        const $$textMedia = document.querySelectorAll('[data-research-ai-landingpage-textmedia="root"]');
        for (let i = 0; i < $$textMedia.length; i++) {
            const $textMedia = $$textMedia[i];

            const $textMediaAPI = new TextMedia($textMedia);
            $textMediaAPI.initialize();
        }

        // Bento
        const $$bento = document.querySelectorAll('[data-research-ai-landingpage-bento="root"]');
        for (let i = 0; i < $$bento.length; i++) {
            const $bento = $$bento[i];

            const $bentoAPI = new Bento($bento);
            $bentoAPI.initialize();
        }

        // Content Slider
        const $$contentSlider = document.querySelectorAll('[data-research-ai-landingpage-contentslider="root"]');
        for (let i = 0; i < $$contentSlider.length; i++) {
            const $contentSlider = $$contentSlider[i];

            const $contentSliderAPI = new ContentSlider($contentSlider);
            $contentSliderAPI.initialize();
        }

        /* COMPONENTS */
        // Floating Bar
        const $$floatingBar = document.querySelectorAll('[data-research-ai-landingpage-floatingbar="root"]');
        for (let i = 0; i < $$floatingBar.length; i++) {
            const $floatingBar = $$floatingBar[i];

            const $floatingBarAPI = new FloatingBar($floatingBar);
            $floatingBarAPI.initialize();
        }

        // Sticky Bulbs
        const $$stickyBulbs = document.querySelectorAll('[data-research-ai-landingpage-stickybulbs="root"]');
        for (let i = 0; i < $$stickyBulbs.length; i++) {
            const $stickyBulbs = $$stickyBulbs[i];

            const $stickyBulbsAPI = new StickyBulbs($stickyBulbs);
            $stickyBulbsAPI.initialize();
        }

        window.setTimeout(() => {
            checkInview();
        }, 750);

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: document,
            },
        });

        window.dispatchEvent(contentUpdateEvent);
    };

    initApplication();
});
